/**
 * @typedef {'VAT_INCLUSIVE'|'VAT_EXCLUSIVE'|'NON_VAT'} VatType
 */

export const getVatRate = () => {
  const standardVat = Number(process.env.VUE_APP_STANDARD_VAT)
  if (!standardVat || isNaN(standardVat)) throw new Error('env VUE_APP_STANDARD_VAT is not declared!')
  return standardVat
}

/**
 * Description
 * @param {VatType} vatType
 * @param {number} subtotal
*/
export const computeQuotationSubtotal = (vatType, subtotal) => {
  if (!vatType) throw new Error('vatType is null or undefined')
  if (vatType === 'VAT_INCLUSIVE') return subtotal / (1 + getVatRate())
  return subtotal
}
/**
 * Description
 * @param {VatType} vatType
 * @param {number} subtotal
 * @param {number} discountRate
*/
export const computeQuotationDiscount = (vatType, subtotal, discountRate) => computeQuotationSubtotal(vatType, subtotal) * discountRate


/**
 * Description
 * @param {VatType} vatType
 * @param {number} subtotal
 * @param {number} discountRate
 */
export const computeQuotationTotalVatEx = (vatType, subtotal, discountRate) => computeQuotationSubtotal(vatType, subtotal) - computeQuotationDiscount(vatType, subtotal, discountRate)


/**
 * Description
 * @param {VatType} vatType
 * @param {number} subtotal
 * @param {number} discountRate
 */
export const computeQuotationTotalVatAmount = (vatType, subtotal, discountRate) => {
  const standardVat = getVatRate()
  if (vatType === 'NON_VAT') return 0
  return computeQuotationTotalVatEx(vatType, subtotal, discountRate) * standardVat
}

/**
 * Description
 * @param {VatType} vatType
 * @param {number} subtotal
 * @param {number} discountRate
 */
export const computeQuotationTotalAmount = (vatType, subtotal, discountRate) => computeQuotationTotalVatEx(vatType, subtotal, discountRate) + computeQuotationTotalVatAmount(vatType, subtotal, discountRate)

/**
 * Description
 * @param {VatType} vatType
 */
export const getVatSymbol = (vatType) => {
  if (vatType === 'NON_VAT') return '-'
  return (getVatRate() * 100) + '%'
}